import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import Reporter from '@tencent/vft-common/Reporter';
import { globalObject } from '@tencent/vft-common/system';

import { LOGIN_VERSION } from './config';
import { getVuid } from './helper';
import sign from './sign';

const reporter = new Reporter('z9e00007481', '2926793681');

reporter.init({
  f_lib_version: LOGIN_VERSION,
  f_guid: cookie.get('guid') || cookie.get('video_guid'),
  f_video_platform: cookie.get('video_platform'),
  f_ext: 'login-core',
  f_qimei36: cookie.get('vdevice_qimei36'),
  f_sdk: 'H5Login',
});

if (globalObject?.addEventListener) {
  globalObject.addEventListener('load', () => { // 待页面加载完再进行上报
    reporter.ready();
  });
}

export async function report(params) {
  params.f_vuserid = getVuid();
  if (!env.isApp && !env.isTenvideoUnion) {
    params.f_h38 = await sign.getH38();
  }
  reporter.report(params);
}

// ---------------- Login 库事件
export const EVENT_INIT_START = 'INIT_START';                          // login库 - 初始化开始
export const EVENT_INIT_SYNC = 'INIT_SYNC';                            // login库 - 初始化同步登录态
export const EVENT_INIT_GETCOOKIE = 'INIT_GETCOOKIE';                  // login库 - 初始化获取 cookie
export const EVENT_INIT_REFRESH = 'INIT_REFRESH';                      // login库 - 初始化续期登录态
export const EVENT_INIT_READY = 'INIT_READY';                          // login库 - 初始化完成
export const EVENT_INIT_LOGIN = 'INIT_LOGIN';                          // login库 - 登录
export const EVENT_INIT_LOGOUT = 'INIT_LOGOUT';                        // login库 - 退出登录
export const EVENT_INIT_REQUEST = 'INIT_REQUEST';                      // login库 - 请求接口
export const EVENT_INIT_COOKIE_ONLOAD = 'INIT_COOKIE_ONLOAD';          // login库 - cookie加载完成
export const EVENT_INIT_COOKIE_LOADED = 'INIT_COOKIE_LOADED';          // login库 - cookie同步
export const EVENT_INIT_COOKIE_READY = 'INIT_COOKIE_READY';          // login库 - cookie同步
export const EVENT_INIT_COOKIE_TIMEOUT = 'INIT_COOKIE_TIMEOUT';        // login库 - cookie超时
export const EVENT_MQQ_NATIVE_LOGIN_REFRESH_FAIL = 'MQQ_NATIVE_LOGIN_REFRESH_FAIL';   // 手Q互联手动取消授权，刷票失败
export const EVENT_MQQ_NATIVE_LOGIN_LOAD_JSAPI_FAIL = 'MQQ_NATIVE_LOGIN_LOAD_JSAPI_FAIL'; // 手Q互联授权jsapi加载失败
export const EVENT_MQQ_NATIVE_LOGIN_TIMEOUT = 'MQQ_NATIVE_LOGIN_TIMEOUT'; // 手Q互联授权超时

// ---------------- 登录页事件
export const EVENT_LOGIN_INIT = 'LOGIN_INIT';              // 登录页 - 初始化
export const EVENT_LOGIN_START = 'LOGIN_START';            // 登录页 - 开始登录
export const EVENT_LOGIN_AUTH = 'LOGIN_AUTH';              // 登录页 - 登录回调授权
export const EVENT_LOGIN_FAIL = 'LOGIN_FAIL';              // 登录页 - 登录失败
export const EVENT_LOGIN_TIMEOUT = 'LOGIN_TIMEOUT';        // 登录页 - 登录超时

